export const NOTIFICATION_GET_DATA = 'NOTIFICATION_GET_DATA'
export const NOTIFICATION_GET_DATA_SUCCESS = 'NOTIFICATION_GET_DATA_SUCCESS'
export const NOTIFICATION_GET_DATA_FAILURE = 'NOTIFICATION_GET_DATA_FAILURE'
export const NOTIFICATION_SET_PID = 'NOTIFICATION_SET_PID'
export const NOTIFICATION_SHOW_MODAL = 'NOTIFICATION_SHOW_MODAL'
export const NOTIFICATION_EMPTY = 'NOTIFICATION_EMPTY'
export const NOTIFICATION_SET_REQUEST_PERMISSION_ID = 'NOTIFICATION_SET_REQUEST_PERMISSION_ID'
export const NOTIFICATION_UNSET_REQUEST_PERMISSION_ID = 'NOTIFICATION_UNSET_REQUEST_PERMISSION_ID'
export const ENABLE_SOCKET = 'ENABLE_SOCKET'